import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Step12 } from '../../../../shared/models/component-messages/mapaIN/step12';
import { TypeVoie } from '../models/TypeVoie';
@Component({
  selector: 'app-type-voie',
  templateUrl: './type-voie.component.html'
})
export class TypeVoieComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'TypeVoie';
  @Input() parentForm: FormGroup;
	@Input() disabled: boolean;
  @Input() errorMessage : string;
	
	@Input() voie: TypeVoie;


  public step12 = new Step12();

  constructor() { }

  public ngOnInit() {}
  
  
  
  
  
  

  
  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }
  
  
}

